import { Box, ButtonBase } from '@mui/material'
import { colorTokens } from '../../../../shared/styles/theme'
import { RADIUS } from '../../../../shared/styles/radii'

/**
 * 「これからの処方箋を遠隔へ」。一覧の下(「設定 / ポータルを開く」の上)の 1 行で、行全体が `role="checkbox"`。
 * 箱は design-book `checkbox.md` の SoapCheckbox と同じ無彩色(14px・輪郭 fg.faint・印 fg.default)。
 * portal 用の NotionCheckbox(accent 青)は使わない — 画面で色が塗られているのは「レセコンに送信」だけ。
 *
 * 依頼先の設定がある店だけ描く(gate は「出さない」で行う)。オンの間に読み取りが終わった紙は
 * 自動で依頼になり、完了時の自動送信をしない。既に頼んだ分はオフにしてもそのまま。
 */
export const RouteToggle = ({
  isOn,
  disabled,
  onToggle,
}: {
  isOn: boolean
  disabled?: boolean
  onToggle: () => void
}) => (
  <ButtonBase
    role="checkbox"
    aria-checked={isOn}
    disabled={disabled}
    onClick={onToggle}
    sx={{
      mx: 1,
      mb: 0.5,
      px: 1,
      height: 28,
      justifyContent: 'flex-start',
      gap: 1,
      borderRadius: `${RADIUS.md}px`,
      fontSize: 13,
      color: colorTokens.fg.default,
      transition: 'background-color 120ms',
      '&:hover': { background: colorTokens.bg.emphasis },
      '&:focus-visible': { boxShadow: colorTokens.focus.ringNeutral },
    }}
  >
    <Box
      component="span"
      aria-hidden
      sx={{
        width: 14,
        height: 14,
        flexShrink: 0,
        border: `1px solid ${colorTokens.fg.faint}`,
        borderRadius: '2px',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {isOn && (
        <svg width="10" height="10" viewBox="0 0 10 10">
          <path
            d="M1.5 5.2 4 7.6 8.6 2.4"
            fill="none"
            stroke={colorTokens.fg.default}
            strokeWidth="2.4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
    </Box>
    これからの処方箋を遠隔へ
  </ButtonBase>
)
